import { models } from "@/mocks/homeData";
import SectionHeading from "@/components/base/SectionHeading";

export default function Models() {
  return (
    <section id="models" className="scroll-mt-24 bg-background-50 px-4 py-16 md:px-8 md:py-24">
      <div className="mx-auto max-w-6xl">
        <SectionHeading
          eyebrow="Featured Models"
          title="人气女主"
          desc="不同拍摄风格下的女主人像，每位都有代表性的造型与光影语言，帮助你更快找到偏爱的审美方向。"
        />

        <div className="mt-10 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {models.map((model) => (
            <article
              key={model.id}
              className="group relative overflow-hidden rounded-lg border border-background-200"
            >
              <div className="relative aspect-[4/5] w-full overflow-hidden">
                <img
                  src={model.cover}
                  alt={`${model.name} 写真合集封面`}
                  title={`${model.name} 写真合集 · ${model.style}`}
                  className="h-full w-full object-cover object-top transition duration-700 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/88 via-foreground-950/25 to-transparent" />
                <span className="absolute left-3 top-3 rounded-full bg-accent-500 px-3 py-1 text-xs font-medium text-foreground-950">
                  {model.tag}
                </span>
                <div className="absolute inset-x-0 bottom-0 p-5">
                  <h3 className="font-heading text-xl font-bold text-background-50">
                    {model.name}
                    <span className="ml-2 text-xs font-normal text-background-200">
                      {model.alias}
                    </span>
                  </h3>
                  <p className="mt-1 text-xs text-background-200">{model.style}</p>
                  <div className="mt-3 flex flex-wrap items-center gap-4 text-xs text-background-100">
                    <span className="flex items-center gap-1">
                      <i className="ri-gallery-line" />
                      {model.albums} 组写真
                    </span>
                    <span className="flex items-center gap-1">
                      <i className="ri-heart-3-line" />
                      {model.followers} 关注
                    </span>
                  </div>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}